import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ScreenRecordingDetector from "../../components/CheckRecording";
import { toast } from "react-toastify"; // Import toast from react-toastify
import "react-toastify/dist/ReactToastify.css";
import Timer from "./Timer";
const apiBase = process.env.REACT_APP_API;

const VideoSkeleton = () => {
  return (
    <div className="w-full">
      <div className="flex flex-col items-center">
        <div className="w-full lg:w-[1024px]">
          <div
            className="mt-36 mx-4"
            style={{ position: "relative", paddingTop: "56.25%" }}
          >
            <div
              className="rounded-lg bg-gray-300 animate-pulse"
              style={{
                position: "absolute",
                top: "0",
                height: "100%",
                width: "100%",
              }}
            ></div>
          </div>
          <div className="mx-4 my-4 rounded-lg bg-gray-300 animate-pulse p-4 md:p-8 h-16"></div>
        </div>
      </div>
    </div>
  );
};

const Video = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [videoDetail, setVideoDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVideoDetail = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      setLoading(true);
      try {
        const response = await fetch(`${apiBase}/lessons/user/video/${id}`, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) throw response;

        const data = await response.json();
        if (data.error) throw data.error;
        setVideoDetail(data);
      } catch (error) {
        const data = await error.json();
        toast.error(data.message);
        navigate("/");
      } finally {
        setLoading(false);
      }
    };
    fetchVideoDetail();
  }, [id, navigate]);

  const onTimeOver = () => {
    navigate(-1);
    toast.error("Your Time is Over!");
  };

  if (loading) {
    return <VideoSkeleton />;
  }

  return (
    <div className="w-full">
      <div className="flex flex-col items-center">        <div className="w-full lg:w-[1024px]">
    
          <div
            className="mx-4 mt-36"
            style={{ position: "relative", paddingTop: "56.25%" }}
          >
            <iframe
              className="rounded-lg"
              src={`https://iframe.mediadelivery.net/embed/${videoDetail?.video?.onlineLibId}/${videoDetail?.video?.URL}?autoplay=false&loop=false&muted=false&preload=true&responsive=true`}
              loading="lazy"
              style={{
                border: "0",
                position: "absolute",
                top: "0",
                height: "100%",
                width: "100%",
              }}
              allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <div className="title mx-4 my-4 rounded-lg bg-myBlue p-4 text-base md:text-lg font-semibold text-white">
            {videoDetail?.video?.title}
            {/* <ScreenRecordingDetector/> */}
          </div>  
                <div className=" mx-4 mb-1">
            <Timer
              lessonId={videoDetail?.video?.lesson_id}
              initialTimeLeft={videoDetail?.timeLeft}
              onTimeOver={onTimeOver}
            />
          </div>
                </div>
      </div>
    </div>
  );
};

export default Video;
